<template>
  <div class="Categoria__Wrapper">
    <v-row>
      <v-col cols="12" sm="3">
        <metadados-extensao-form
          ref="CategoriaForm"
          :id="idCategoria"
          :idNivelExtensao="idNivelExtensao"
          :somenteLeitura="somenteLeitura"
          :indRecursiva="item.indRecursiva"
          :tipoCadastro="$tc(`label.${item.label.toLowerCase()}`, 1)"
          :input-layout="inputLayout">
          <template slot="contentPreForm">
            <v-col cols="12">
              <v-select
                class="Form-text__invalid"
                id="tipo"
                name="tipo"
                item-text="nome"
                item-value="id"
                return-object
                clearable
                :items="tipos"
                :disabled="!!idCategoria || somenteLeitura"
                @input="carregarExtensoesPais"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                :label="`${$tc('label.tipo', 1)} *`"
                v-model="objeto.tipo"
                :rules="[rules.required]">
              </v-select>
            </v-col>
          </template>
          <template slot="contentPosForm">
            <v-col cols="12">
              <v-autocomplete
                class="Form-text__invalid"
                id="pai"
                name="pai"
                v-model="objeto.pai"
                item-text="nomExtensao"
                item-value="id"
                :label="`${$tc('label.pai', 1)} ${montarDescricaoTipoLabel()} ${maiorIndice == (objeto.tipo && objeto.tipo.indice ? objeto.tipo.indice : objeto.indice) ? '' : '*'}`"
                :items="pais"
                :no-data-text="$tc('message.nenhum_registro', 1)"
                :filter="filtroPai"
                :search-input.sync="buscaListaPais"
                :rules="[rules.requiredPai]"
                :disabled="!!idCategoria || somenteLeitura"
                clearable
                return-object>
              </v-autocomplete>
            </v-col>
          </template>
          <template slot="button">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.native="cancelar" :disabled="somenteLeitura">{{ $t('label.cancelar') }}</v-btn>
              <v-btn @click.native="abrirDialogSalvar" color="primary" :disabled="somenteLeitura">{{ $t('label.salvar') }}</v-btn>
            </v-card-actions>
          </template>
        </metadados-extensao-form>
      </v-col>
      <v-col cols="12" sm="9">
        <categoria-tabela
          ref="CategoriaTabela"
          id="categoria-tabela"
          :titlePage="item.indRecursiva ? `${$t('label.hierarquia_de')}: ${item.entidadeEstrangeira}` : item.entidadeEstrangeira"
          :idNivelExtensao="idNivelExtensao"
          @edit="editarCampo"
          :somenteLeitura="somenteLeitura"
          class="Categoria__ContentTable"/>
      </v-col>
    </v-row>
    <confirm
      ref="confirmDialog"
      :message="$t('message.deseja_salvar', { text: $tc(`label.${item.label}`, 1) })"
      :persistent="true"
      @agree="salvar">
    </confirm>
  </div>
</template>

<script type="text/javascript">
import { mapGetters } from 'vuex';
import MetadadosExtensaoForm from '@/shared-components/metadados-extensao/MetadadosExtensaoForm';
import Confirm from '@/shared-components/dialog/Confirm';
import CategoriaTabela from './CategoriaTabela';

export default {
  name: 'TabelaGenericaRecursiva',
  data() {
    return {
      idCategoria: null,
      inputLayout: {
        ml1: false,
        mt1: false,
        mt2: true,
      },
      maiorIndice: null,
      pais: [],
      objeto: {
        indAtivo: true,
      },
      objetoLabelSelecionado: {},
      tipos: [],
      buscaListaPais: null,
      extensaoResources: this.$api.extensao(this.$resource),
      nivelProdutoResources: this.$api.nivelProduto(this.$resource),
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredPai: value => this.tipoValido() ? true : // eslint-disable-line
          (!this.tipoValido() && !value ? this.$t('message.campo_obrigatorio') : true), // eslint-disable-line
      },
    };
  },
  props: {
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    idNivelExtensao: Number,
  },
  components: {
    CategoriaTabela,
    Confirm,
    MetadadosExtensaoForm,
  },
  watch: {
    buscaListaPais(val) {
      if (this.timeoutProduto) {
        window.clearTimeout(this.timeoutProduto);
      }
      this.timeoutProduto = window.setTimeout(() => {
        this.buscarPaiAutocomplete(val);
      }, 500);
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
  },
  methods: {
    abrirDialogSalvar() {
      if (!this.$refs.CategoriaForm.validarFormulario()) return;
      this.$refs.confirmDialog.open();
    },
    atualizarGrid() {
      this.$refs.CategoriaTabela.filtrar();
    },
    buscarMetadadosLabels() {
      return this.nivelProdutoResources.labels().then((resultado) => {
        this.tipos = resultado.data;
        this.maiorIndice = Math.max(...this.tipos.map((tipo) => tipo.indice));
      });
    },
    cancelar() {
      this.limparFormulario();
    },
    carregarExtensoesPais(objeto) {
      if (!objeto) return;
      this.$refs.CategoriaForm.limparValidacoes();
      this.objetoLabelSelecionado = objeto;
      const filtroDesAtributo = 'indiceLabel';
      const filtroDesAtributoValor = objeto.indice + 1;
      const params = {
        ...null,
        idNivelExtensao: this.idNivelExtensao,
        limit: 30,
        tamanhoPagina: 30,
        filtroDesAtributo,
        filtroDesAtributoValor,
      };

      if (this.idCategoria != null) {
        params.limit = 200;
        params.tamanhoPagina = 200;
      }

      this.extensaoResources.listarAtivos(params).then((resultado) => {
        this.pais = resultado.data.resposta;
      });
    },
    filtroPai(item, queryText, itemText) {
      const codPai = item.idExterno;
      const searchText = queryText.toLowerCase();

      return codPai.toLowerCase().indexOf(searchText) > -1
        || itemText.toLowerCase().indexOf(searchText) > -1;
    },
    buscarPaiAutocomplete(busca = null) {
      const filtroDesAtributo = 'indiceLabel';
      const filtroDesAtributoValor = this.objetoLabelSelecionado.indice + 1;
      const params = {
        ...null,
        idNivelExtensao: this.idNivelExtensao,
        autocomplete: busca,
        limit: 30,
        tamanhoPagina: 30,
        page: 0,
        filtroDesAtributo,
        filtroDesAtributoValor,
      };

      if (this.idCategoria != null) {
        params.limit = 200;
        params.tamanhoPagina = 200;
      }

      this.extensaoResources.listarAtivos(params).then((resultado) => {
        this.pais = resultado.data.resposta;
      }, (err) => {
        this.$error(this, err);
      });
    },
    editarCampo(item) {
      this.idCategoria = item.id;
      item = this.setAtributos(item);
      this.$refs.CategoriaForm.iniciarEdicao(item);
    },
    limparFormulario() {
      this.$refs.CategoriaForm.limparFormulario();
      this.objetoLabelSelecionado = {};
      this.pais = [];
      this.idCategoria = null;
    },
    montarDesAtributos() {
      const desAtributos = {};

      if (this.objetoHasProperties(this.objetoLabelSelecionado)) {
        return desAtributos;
      }

      desAtributos.nomeLabel = this.objetoLabelSelecionado.label;
      desAtributos.indiceLabel = this.objetoLabelSelecionado.indice;
      return desAtributos;
    },
    montarDescricaoTipoLabel() {
      if (this.pais && this.pais.length > 0) {
        return this.pais[0].desAtributos && this.pais[0].desAtributos.nomeLabel
          ? `(${this.pais[0].desAtributos.nomeLabel})` : '';
      }
      return '';
    },
    objetoHasProperties(objeto) {
      if (typeof (objeto) === 'number') {
        return false;
      }

      return Object.keys(objeto).length === 0
        && objeto.constructor === Object;
    },
    prepararObjeto() {
      const objetoComponente = this.$refs.CategoriaForm.prepararObjeto();
      this.objeto.pai = this.objeto.pai
        ? this.objeto.pai.id || this.objeto.pai : null;
      this.objeto.id = objetoComponente.id;
      this.objeto.idExterno = objetoComponente.idExterno;
      this.objeto.nomExtensao = objetoComponente.nomExtensao;
      this.objeto.indAtivo = objetoComponente.indAtivo;
      this.objeto.idNivelExtensao = this.idNivelExtensao;
      this.objeto.desAtributos = this.montarDesAtributos();
      return this.objeto;
    },
    salvar() {
      if (this.idCategoria) {
        this.extensaoResources.atualizarAutoRelacionamento({ id: this.id }, this.prepararObjeto())
          .then(() => {
            this.$toast(this.$t('message.atualizado_confira_tabela'));
            this.limparFormulario();
            this.atualizarGrid();
          }, (err) => {
            this.$error(this, err);
          });
      } else {
        this.extensaoResources.gravarAutoRelacionamento(this.prepararObjeto())
          .then(() => {
            this.$toast(this.$t('message.adicionado_confira_tabela'));
            this.limparFormulario();
            this.atualizarGrid();
          }, (err) => {
            this.$error(this, err);
          });
      }
    },
    setAtributos(item) {
      item.tipo = item.idMetadadosExtensaoRecursiva;
      item.pai = item.idPai;
      this.carregarExtensoesPais(this.tipos.filter((tipo) => tipo.id === item.tipo)[0]);
      this.objeto.tipo = item.idMetadadosExtensaoRecursiva;
      this.objeto.indice = parseInt(item.indice, 10);
      this.objeto.pai = item.idPai;
      return item;
    },
    tipoValido() {
      if (this.objeto) {
        return this.maiorIndice === (this.objeto.tipo && this.objeto.tipo.indice
          ? this.objeto.tipo.indice : this.objeto.indice);
      }
      return true;
    },
  },
  mounted() {
    this.buscarMetadadosLabels();
    if (this.isTenantEpoca) {
      this.somenteLeitura = true;
    }
  },
};
</script>
<style>
  .Categoria__ContentTable {
    width: 100% !important;
  }
</style>
